import { render, staticRenderFns } from "./Tagging.vue?vue&type=template&id=702c14c1&"
import script from "./Tagging.vue?vue&type=script&lang=js&"
export * from "./Tagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports